import React, {useEffect, useRef, useState} from 'react';
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';
import {PromotionTabOptionList} from "./_list";
import {showLoader} from "../../../components/loader/loader";
import Switch from "react-bootstrap-switch";
import {ButtonCancel, ButtonClean, ButtonSubmit} from "../../../components/buttons/buttonsActions";
import {tabOptionProvider} from "../../../providers/tabOptionProvider";
import {showToastCustom} from "../../../components/toast/customToast";
import {error, info, infoMsg, saveMsg, selectOption, success, updateMsg} from "../../../components/i18n/i18n";
import {useForm} from "react-hook-form";
import {promotionTabOptionService} from "../../../jwt/_services/relations/promotionTabOptionService";
import SelectGeneric from "../../../components/select/selectGeneric";
import {setLoading, setViewMode} from "../../../redux/actions/generalActions/mainActions";
import {resetCombos, setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {save, update} from "../../../redux/actions/promo/promotionActions";
import {connect} from "react-redux";


const PromotionTabOption = (props) => {
    const { domainObject } = props.formProps;

    const [promotion] = useState(domainObject);

    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(false);
    const [tabOptionId, setTabOptionId] = useState(null);
    const [itemToEdit, setItemToEdit] = useState();
    const [editMode, setEditMode] = useState(false);
    const refList = useRef(null);



    const {register, handleSubmit, reset, errors} = useForm({
    });

    const setForm = (_editMode, _itemToEdit) => {
        setEditMode(_editMode);
        setItemToEdit(_itemToEdit);
        if (_itemToEdit) {
            setStatus(_itemToEdit.status);
            setTabOptionId(_itemToEdit.tabOption?.id);
        } else {
            setStatus(false);
            setTabOptionId(null);
        }
    }

    const onSubmit = (data, _) => {
        if (tabOptionId == null) {
            return showToastCustom(error, selectOption);
        }
        setLoading(true);
        const dataRequest = {
            id: data.id,
            uid: data.uid,
            // Objects
            tabOption: { id : tabOptionId },
            promotion:  { id : promotion.id } ,
            status: status
        };

        //Save NO HAY MODO EDICION
        if (!editMode) {
            //Save
            promotionTabOptionService.saveItem(dataRequest)
                .then(_ => {
                    resetForm();
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        } else {
            //Update
            promotionTabOptionService.updateItem(itemToEdit.id, dataRequest)
                .then(_ => {
                    resetForm();
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        }
    };

    const resetForm = () => {
        setEditMode(false);
        setItemToEdit(null);
        setStatus(false);
        setTabOptionId(null);
        setLoading(false);
        refList.current.refreshList();
    }

    const closeForm = () => {
        props.setItem(null);
        props.setForm();
        props.setViewMode("LIST");
    }

    const cleanFields = () => {
        setStatus(null);
        setTabOptionId(null);
        setEditMode(false);
        reset();
    }

    // ----------------------------------------------
    //            CHANGE HANDLERS
    // ----------------------------------------------
    const onStatusChange = () => {
        setStatus(!status);
    }

    return (
        <div>
            {loading && showLoader()}
            {/* --------------------------------------------------------------------------------*/}
            {/* Formulario */}
            {/* --------------------------------------------------------------------------------*/}
            <Row>
                <Col md="12">
                    <Card>
                        <CardTitle className="bg-light border-bottom p-3 mb-0">
                            <i className="fas fa-clock mr-2"/>
                            Tabs de la promocion { promotion.code  ? " : " + promotion.code : "" }
                        </CardTitle>
                        <CardBody>
                            <Form onSubmit={handleSubmit(onSubmit)}>
                                <Row>
                                    <Col md="4">
                                        <FormGroup>
                                            <Label>Tab</Label>
                                            {
                                                editMode ?
                                                    <Input type="text" name="tabOption"
                                                           value={ itemToEdit.tabOption?.code }
                                                           innerRef={register}
                                                           disabled={true}
                                                    />
                                                    :
                                                    <SelectGeneric
                                                        initialValue={ tabOptionId }
                                                        setExternalValue={ setTabOptionId }
                                                        provider = { tabOptionProvider }
                                                    />
                                            }
                                        </FormGroup>
                                    </Col>
                                    <Col md="4">
                                        <FormGroup>
                                            <Label>Activo</Label>
                                            <br/>
                                            <Switch animate={true} offText={"No"} onText={"Si"}
                                                    value={status}
                                                    onChange={onStatusChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <CardBody className="border-top">
                                    <div className="float-right">
                                        <ButtonSubmit/>
                                        {
                                            editMode ?
                                                <ButtonClean onClick={() => cleanFields()}/>
                                                :
                                                <ButtonCancel onClick={closeForm}/>
                                        }
                                    </div>
                                </CardBody>
                            </Form>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            {/* --------------------------------------------------------------------------------*/}
            {/* Listado */}
            {/* --------------------------------------------------------------------------------*/}
            <Row>
                <Col md="12">
                    <PromotionTabOptionList setForm={setForm} promotion={promotion} ref={refList}/>
                </Col>
            </Row>

        </div>
    );
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    setViewMode,
    resetCombos,
    setItem,
    setForm,
    save,
    update,
    setLoading
})

export default connect(mapStateToProps, mapActionsToProps)(PromotionTabOption)
